const actions = {
  ADD_AGENT: "ADD_AGENT",
  ADD_AGENT_SUCCESS: "ADD_AGENT_SUCCESS",
  ADD_AGENT_FAILED: "ADD_AGENT_FAILED",
  GET_AGENTS_DATA: "GET_AGENTS_DATA",
  GET_AGENTS_DATA_SUCCESS: "GET_AGENTS_DATA_SUCCESS",
  GET_AGENTS_DATA_FAILED: "GET_AGENTS_DATA_FAILED",
  GET_AGENTS_DATA_RESET: "GET_AGENTS_DATA_RESET",
  UPDATE_AGENT: "UPDATE_AGENT",
  UPDATE_AGENT_SUCCESS: "UPDATE_AGENT_SUCCESS",
  UPDATE_AGENT_FAILED: "UPDATE_AGENT_FAILED",

  addAgent: (data) => ({
    type: actions.ADD_AGENT,
    payload: { data },
  }),
  addAgentSuccess: (message) => ({
    type: actions.ADD_AGENT_SUCCESS,
    payload: { message },
  }),
  addAgentFailed: (error) => ({
    type: actions.ADD_AGENT_FAILED,
    payload: { error },
  }),

  getAgentsData: () => ({
    type: actions.GET_AGENTS_DATA,
  }),
  getAgentsDataSuccess: (data) => ({
    type: actions.GET_AGENTS_DATA_SUCCESS,
    payload: { data },
  }),
  getAgentsDataFailed: (error) => ({
    type: actions.GET_AGENTS_DATA_FAILED,
    payload: { error },
  }),
  getAgentsDataReset: () => ({
    type: actions.GET_AGENTS_DATA_RESET,
  }),
  updateAgent: (orgId, payload) => ({
    type: actions.UPDATE_AGENT,
    payload: { orgId, payload },
  }),
  updateAgentSuccess: (orgId, message) => ({
    type: actions.UPDATE_AGENT_SUCCESS,
    payload: { orgId, message },
  }),
  updateAgentFailed: (error) => ({
    type: actions.UPDATE_AGENT_FAILED,
    payload: { error },
  }),
};

export default actions;